import $ from "jquery";

const MODAL_SELECTOR       = "#cardInfoModal";
const MODAL_TITLE_SELECTOR = ".modal-title";
const MODAL_BODY_SELECTOR  = ".modal-body";

const setModalContent = function(modal, title, body) {
  modal.find(MODAL_TITLE_SELECTOR).text(title);
  modal.find(MODAL_BODY_SELECTOR).html(body);
};

const linkClicked = function(e) {
  e.preventDefault();

  const $modal = $(MODAL_SELECTOR);
  const title = $(this).data("disclaimer-title");
  const body  = $(this).data("disclaimer-content");

  setModalContent($modal, title, body);
  $modal.modal("show");
};

$(document).on("turbolinks:load", function() {
  $(".about-this-data").on("click", linkClicked);
});
